module.exports = __webpack_public_path__ + "img/invite-members.8e810df4.svg";